import { inject, Injectable, NgZone, signal } from '@angular/core';
import { Router } from '@angular/router';
import { SupabaseService } from './supabase.service';
import { ToastService } from './toast.service';
import { CustomNotificationService } from './customNotificationService.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationPushService {
  private readonly router = inject(Router);
  private readonly ngZone = inject(NgZone);
  private readonly supabaseService = inject(SupabaseService);
  private readonly customToast = inject(CustomNotificationService);

  private activeChannel: any = null;

  public unreadCount = signal<number>(0);

  constructor() {
    this.requestBrowserPermission();
  }

  private requestBrowserPermission() {
    if ('Notification' in window && Notification.permission !== 'granted') {
      Notification.requestPermission();
    }
  }

  // Llama a este método tras hacer Login exitoso
  listenToRealtime(userId: string) {
    if (!userId) return;

    const channelName = `notificaciones-${userId}`;

    this.fetchInitialUnreadCount(userId);

    if (this.activeChannel && this.activeChannel.topic === `realtime:${channelName}`) {
      return;
    }

    if (this.activeChannel) {
      this.supabaseService.client.removeChannel(this.activeChannel);
      this.activeChannel = null;
    }

    console.log(`Conectando WebSocket para usuario: ${userId}`);

    // ESCUCHAMOS SOBRE 'notification_user'
    this.activeChannel = this.supabaseService.client
      .channel(channelName)
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'notification_user',
          filter: `user_id=eq.${userId}`
        },
        async (payload) => {
          // Buscamos el detalle completo de la notificación y su plantilla
          const { data: fullNotification, error } = await this.supabaseService.client
            .from('notification')
            .select(`
              *,
              template:notification_template (
                icon,
                color,
                notification_type,
                requires_encryption
              )
            `)
            .eq('id', payload.new['notification_id'])
            .single();

          if (error) {
            console.error('Error al obtener la notificación con template:', error);
            return;
          }

          if (fullNotification) {
            // Unimos el registro pivot (para tener el nu.id y marcar is_read luego) con la info
            const { template, ...notificationData } = fullNotification;

            // 2. Construimos un objeto limpio y estructurado
            const cleanData = {
              pivot_id: payload.new['id'],      // ID de notification_user 
              is_read: payload.new['is_read'],
              notification: notificationData,   // Info pura de la notificación
              template: template                // Template totalmente separado a la par
            };

            console.log('Notificación procesada:', cleanData);

            // Es OBLIGATORIO usar NgZone para que Angular detecte el cambio y pinte el Toast
            this.ngZone.run(() => {
              this.unreadCount.update(c => c + 1);
              this.customToast.show(cleanData);
            });
          }
        }
      )
      .subscribe();
  }


  private async fetchInitialUnreadCount(userId: string) {
    const { count, error } = await this.supabaseService.client
      .from('notification_user')
      .select('*', { count: 'exact', head: true }) // head: true evita descargar toda la data, solo trae el número
      .eq('user_id', userId)
      .eq('is_read', false);

    if (!error && count !== null) {
      this.ngZone.run(() => {
        this.unreadCount.set(count);
      });
    }
  }

  // 5. Método para descontar cuando el usuario lee una notificación
  public markAsReadLocally() {
    this.unreadCount.update(c => Math.max(0, c - 1));
  }



  

}